import {
  trackExposedToDeferSitename,
  TrackExposedToDeferSitename
} from '../service/sign-up-form/analytics';
import { useEffect } from 'react';
import { getDeferSitenameExperimentCohort } from '../layouts/legacy/view/utility/get-defer-sitename-experiment-cohort';

type Params = Omit<TrackExposedToDeferSitename, 'value'> & {
  exposedToDeferSitename: boolean;
};

export function useDeferSitenameExposed({
  createAnalyticsEvent,
  products,
  exposedToDeferSitename
}: Params) {
  useEffect(() => {
    if (exposedToDeferSitename) {
      trackExposedToDeferSitename({
        createAnalyticsEvent,
        value: getDeferSitenameExperimentCohort(),
        products
      });
    }
  }, [createAnalyticsEvent, exposedToDeferSitename]);
}
